<template>
  <div
    style="padding: 15px"
    class="bg-white"
    label-position="top"
    v-loading="isLoading"
  >
    <el-row>
      <el-col :sm="12">
        <h4 class="form-title">Repair - Manufacturer</h4>
      </el-col>
      <el-col :sm="12">
        <div class="d-flex justify-content-flex-end">
          <el-button type="primary" size="small" @click="openDrawer">
            Add Manufacturer
          </el-button>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="data.data">
          <el-table-column label="Actions" width="80">
            <template slot-scope="scope">
              <el-button
                type="primary"
                icon="el-icon-edit"
                title="Edit information"
                circle
                size="small"
                @click="edit(scope.row)"
              ></el-button>
            </template>
          </el-table-column>
          <!-- <el-table-column label="Spare Part" prop="jo_part"></el-table-column> -->
          <el-table-column label="Name" prop="name"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-pagination
      v-show="!isLoading"
      class="pt-1 pb-1"
      background
      layout="prev, pager, next"
      :total="data.paging.total"
      :page-size="pager.limit"
      :current-page="parseInt(data.paging.cur_page)"
      @current-change="fetch"
    >
    </el-pagination>
    <el-drawer
      ref="drawer"
      size="45%"
      :visible.sync="viewDrawer"
      v-loading="isLoading"
      :destroy-on-close="true"
      @close="closeDrawer"
    >
      <div class="el-drawer__content">
        <el-form ref="form" :model="formModel" :rules="rules">
          <el-form-item label="Name" prop="name">
            <el-input v-model="formModel.name"></el-input>
          </el-form-item>
        </el-form>
        <div class="el-drawer__footer">
          <el-button size="small" type="primary" @click="save">Save</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Manufacturer from "@/models/Manufacturer";
export default {
  name: "Manufacturer",

  data() {
    return {
      formModel: new Manufacturer(),
      rules: {
        name: [{ required: true, message: "Manufacturer name is required." }]
      },
      data: { paging: {}, data: [] },
      isLoading: false,
      pager: {
        limit: 25
      },
      viewDrawer: false
    };
  },
  methods: {
    fetch(page) {
      this.isLoading = true;
      this.pager.page = 1;
      if (page) {
        this.pager.page = page;
      }
      Manufacturer.list(this.pager).then(list => {
        this.isLoading = false;
        if (list) this.data = list;
      });
    },
    edit(item) {
      this.viewDrawer = true;
      this.formModel = new Manufacturer({
        id: item.id,
        // jo_part_id: item.jo_part_id,
        name: item.name
      });
    },
    openDrawer() {
      this.viewDrawer = true;
    },
    closeDrawer() {
      this.formModel = new Manufacturer();
    },
    save() {
      this.$confirm("Do you want to save the Manufacturer information?")
        .then(() => {
          this.$refs.form.validate(valid => {
            if (!valid) return false;
            this.isLoading = true;
            if (this.formModel.id) {
              Manufacturer.update(this.formModel).then(resp => {
                if (resp.code == 200) {
                  this.$refs.drawer.closeDrawer();
                  this.formModel = new Manufacturer();
                  this.fetch();
                  this.isLoading = false;
                  this.$notify({
                    type: "success",
                    message: "Repair Manufacturer information saved.",
                    position: "bottom-right"
                  });
                }
              });
            } else {
              Manufacturer.store(this.formModel).then(resp => {
                this.isLoading = false;
                if (resp.code == 200) {
                  this.$notify({
                    type: "success",
                    message: "Repair Manufacturer information saved.",
                    position: "bottom-right"
                  });
                  this.$refs.drawer.closeDrawer();
                  this.formModel = new Manufacturer();
                  this.fetch();
                }
              });
            }
          });
        })
        .catch(() => {});
    }
  },
  mounted() {
    this.fetch();
  }
};
</script>

<style lang="css" scoped></style>
